import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;
const ROOT_URL_INIT = Config.defurl;

export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token") }
  };
}

function pushloggingx(requests, description) {
  const url = `${ROOT_URL}logactivity/logactivity/`;
  let ippublic = "-";

  const fdata = new FormData();
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("name", localStorage.getItem("name"));
  fdata.append("email", localStorage.getItem("email"));
  fdata.append("issuperuser", localStorage.getItem("is_superuser"));
  fdata.append("ipaddress", localStorage.getItem("ipaddress"));
  fdata.append("location", localStorage.getItem("location"));
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("os", "");
  fdata.append("activity", requests);
  fdata.append("description", description);


  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushNotif(header, body, footer, dateNotif) {
  const url = `${ROOT_URL}notif/notif/`;

  const fdata = new FormData();
  fdata.append('headerText', header);
  fdata.append('bodyText', body);
  fdata.append('footerText', footer);
  fdata.append('status', 1);
  fdata.append('dateNotif', dateNotif);
  fdata.append('date_created', moment().format("YYYY-MM-DD"));

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function updateNotif(header, body, footer, dateNotif, id) {
  const url = `${ROOT_URL}notif/notif/${id}/`;

  const fdata = new FormData();
  fdata.append('headerText', header);
  fdata.append('bodyText', body);
  fdata.append('footerText', footer);
  fdata.append('status', 1);
  fdata.append('dateNotif', dateNotif);
  fdata.append('date_created', moment().format("YYYY-MM-DD"));

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function deleteNotif(id) {
  const url = `${ROOT_URL}notif/notif/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushFaq(description) {
  const url = `${ROOT_URL}faq/faq/1/`;

  const fdata = new FormData();
  fdata.append('description', description);

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushTermcondition(description) {
  const url = `${ROOT_URL}termcondition/termcondition/1/`;

  const fdata = new FormData();
  fdata.append('description', description);

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchNotif() {
  let today = moment().format("YYYY-MM-DD");
  const url = `${ROOT_URL}notif/notif/?search=${today}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchNotifAll() {
  const url = `${ROOT_URL}notif/notif/`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchTermCondition() {
  const url = `${ROOT_URL}termcondition/termcondition/`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchFaq() {
  const url = `${ROOT_URL_INIT}faq/faq/`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchCompany(comp) {
  const url = `${ROOT_URL}company/company/?search=${comp}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchCompanyInit(comp) {
  const url = `${ROOT_URL_INIT}company/company/?search=${comp}`;
  const request = axios.get(url, cekAuth());
  pushloggingx("get " + url, "Login");
  return request;
}
